module.exports = __webpack_public_path__ + "img/GT.57fc1df5.svg";